import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ThreadState {
  selectedThreadId: number | undefined;
}

const initialState: ThreadState = {
  selectedThreadId: undefined
};

const threadSlice = createSlice({
  name: 'thread',
  initialState,
  reducers: {
    setSelectedThread: (state, action: PayloadAction<number | undefined>) => {
      state.selectedThreadId = action.payload;
    }
  }
});

export const { setSelectedThread } = threadSlice.actions;
export default threadSlice.reducer; 